// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.page-header {\n  margin-bottom: 30px;\n  text-align: center;\n}\n.page-header h2 {\n  font-size: 24px;\n  color: #303133;\n  margin: 0 0 10px 0;\n}\n.page-header .page-desc {\n  color: #909399;\n  margin: 0;\n  font-size: 14px;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#30B08F",
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF"
};
module.exports = exports;
